// extracted by mini-css-extract-plugin
export default {"applyTitle":"Header_applyTitle__-oOo7","backBtn":"Header_backBtn__8c5ZV"};